import {useContext} from 'react'
import {DailySoldReportContext} from '../../context'
import DailySoldReportTableRow from './DailySoldReportTableRow'
import {DynamicTable} from '../../../../components/DynamicTable'

function DailySoldReportTable() {
  const {
    isFetchingReplenishmentData,
    replenishment,
    filters,
    onClickSorting,
    register,
    monthly_column,
  } = useContext(DailySoldReportContext)

  const originalObject = monthly_column !== undefined ? monthly_column : {}
  const reversedObject = Object.fromEntries(Object.entries(originalObject).reverse())
  const monthly_column_keys = Object.keys(reversedObject)

  const sortableColumns = [
    {
      key: 'child_data',
      label: '',
      isSorted: false,
      headerStyle: 'min-w-50px w-50px',
    },
    {
      key: 'parent_sku',
      label: 'SKU',
      isSorted: true,
      headerStyle: 'min-w-150px w-150px',
    },
    {
      key: 'product_title',
      label: 'Product Title',
      isSorted: true,
      headerStyle: 'min-w-500px w-500px',
    },
    {
      key: 'reserved_quantity',
      label: 'Blocked Qty',
      isSorted: false,
      headerStyle: 'min-w-150px w-150px text-center',
      style: 'justify-content-center',
    },
    {
      key: 'quantity_available',
      label: 'Available',
      isSorted: true,
      headerStyle: 'min-w-120px w-120px text-center',
      style: 'justify-content-center',
    },
    {
      key: 'quantity_incoming',
      label: 'Incoming',
      isSorted: true,
      headerStyle: 'min-w-120px w-120px text-center border-end',
      style: 'justify-content-center',
    },
    {
      key: 'total_month_quantity',
      label: 'Total',
      isSorted: true,
      headerStyle: 'min-w-100px w-100px text-center ',
      style: 'justify-content-center',
    },
  ]

  const dynamicMonthlyColumns = Object.entries(monthly_column || {})?.reverse().map(
    ([key, value]: any, index, array: any) => {
      const [dayPart, yearPart] = value.split(' / ')
      const month = yearPart.split(' ')[0]
      const prevMonth = index > 0 ? array[index - 1][1].split(' / ')[1].split(' ')[0] : ''
      const monthStart = month !== prevMonth ? yearPart : ''

      return {
        key,
        label: monthStart ? `${monthStart} <br/> ${dayPart}` : dayPart,
        isSorted: true,
        headerStyle: `${
          monthStart ? 'min-w-120px w-120px text-center' : 'min-w-80px w-80px text-center'
        }`,
        style: 'justify-content-center',
      }
    }
  )

  const finalColumns = [
    ...sortableColumns.slice(0, 6),
    ...dynamicMonthlyColumns,
    sortableColumns[6],
  ]

  return (
    <DynamicTable
      data={replenishment || []}
      sortableColumns={finalColumns}
      TableRow={DailySoldReportTableRow}
      loading={isFetchingReplenishmentData ?? true}
      filters={filters}
      onSortingChange={onClickSorting}
      tableClass='table-row-bordered table-row-gray-300 align-middle gs-0 gy-3'
      noDataMessage='No daily sold report data found'
      tableRowProps={{register, monthly_column_keys}}
    />
  )
}

export default DailySoldReportTable
